import axios from "axios";

export const http = axios.create({
  baseURL: "https://api.ralphsys.com/",
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

function pickMessage(item) {
  if (item == null) return null;
  if (typeof item === "string") return item.trim() || null;
  if (typeof item !== "object") return String(item);

  return (
    item.message ||
    item.Message ||
    item.errorMessage ||
    item.ErrorMessage ||
    item.title ||
    item.Title ||
    null
  );
}

function extractMessagesFromData(data) {
  if (data == null) return [];

  if (typeof data === "string") {
    const text = data.trim();
    return text ? [text] : [];
  }

  // API AB: body = [{ code, message }, ...]
  if (Array.isArray(data)) {
    return data
      .map(pickMessage)
      .filter(Boolean);
  }

  if (typeof data !== "object") {
    return [String(data)];
  }

  const single = pickMessage(data);
  if (single) return [single];

  if (Array.isArray(data.errors)) {
    return data.errors.map(pickMessage).filter(Boolean);
  }

  if (Array.isArray(data.Errors)) {
    return data.Errors.map(pickMessage).filter(Boolean);
  }

  // ASP.NET ModelState: { errors: { field: ["msg"] } }
  if (data.errors && typeof data.errors === "object" && !Array.isArray(data.errors)) {
    return Object.values(data.errors)
      .flat()
      .map(pickMessage)
      .filter(Boolean);
  }

  return [];
}

export const handleErrorMessage = function (error) {
  if (!error) {
    return "Erro desconhecido";
  }

  if (error.response) {
    const messages = extractMessagesFromData(error.response.data);
    if (messages.length > 0) {
      return messages.join("; ");
    }

    switch (error.response.status) {
      case 400:
        return "Dados inválidos. Verifique o formulário e tente novamente.";
      case 401:
        return "Não autorizado. Faça login novamente.";
      case 403:
        return "Acesso negado.";
      case 404:
        return "Registro não encontrado.";
      case 409:
        return "Já existe um registro com esses dados.";
      case 500:
        return "Erro interno do servidor. Tente novamente.";
      default:
        return `Erro ${error.response.status}`;
    }
  }

  if (error.request) {
    return "Erro de conexão com o servidor";
  }

  return error.message || "Erro desconhecido";
};
